module.exports = __webpack_public_path__ + "img/KOR.a681e668.svg";